import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/data/site";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0B132B] grain relative text-white">
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="font-display text-4xl md:text-5xl tracking-tight">OKA <span className="italic text-[#8ea2c8]">VTC</span></div>
            <p className="text-white/60 mt-5 max-w-md leading-relaxed">
              Chauffeur privé sur la région lyonnaise. Transferts aéroport, mise à disposition et véhicule de mariage à bord d'une Peugeot 508 SW Hybrid.
            </p>
            <button
              data-testid="footer-reserve-btn"
              onClick={() => scrollTo("booking")}
              className="mt-8 bg-white text-[#0B132B] px-7 py-3.5 text-sm font-semibold hover:bg-[#8ea2c8] transition-colors duration-300"
            >
              Réserver une course
            </button>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#8ea2c8] mb-5">Navigation</div>
            <ul className="space-y-3 text-white/70">
              {[["Prestations", "services"], ["Le véhicule", "vehicle"], ["Approche", "manifesto"], ["Réserver", "booking"]].map(([l, id]) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="hover:text-white transition-colors duration-300">{l}</button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#8ea2c8] mb-5">Contact</div>
            <ul className="space-y-4 text-white/70">
              <li><a href={`tel:${CONTACT.phoneIntl}`} className="flex items-center gap-3 hover:text-white transition-colors duration-300"><Phone className="w-4 h-4" /> {CONTACT.phoneDisplay}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white transition-colors duration-300"><Mail className="w-4 h-4" /> {CONTACT.email}</a></li>
              <li className="flex items-center gap-3"><MapPin className="w-4 h-4" /> {CONTACT.zone}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-white/40 text-xs">
          <span>© {new Date().getFullYear()} OKA VTC. Tous droits réservés.</span>
          <div className="flex items-center gap-5">
            <Link to="/carte" data-testid="footer-card-link" className="hover:text-white transition-colors duration-300">Carte de visite</Link>
            <Link to="/confidentialite" data-testid="footer-privacy-link" className="hover:text-white transition-colors duration-300">Confidentialité</Link>
            <span>Peugeot 508 SW Hybrid 180 Allure — HB-116-DS</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
